<ws-ace-card header="Company Permissions">
    <ng-container card-actions>
        @if (editMode) {
            <button helpTooltip
                    helpContentId="user-group-detail.new-company-permission"
                    type="button"
                    class="ace-btn has-icon btn-text btn-secondary"
                    (click)="addNewCompanyPermission()">
                <i class="fa fa-plus-circle fa-align"></i>
            </button>
        }
        <ag-grid-filter-toggle [gridApi]="gridApi"></ag-grid-filter-toggle>
    </ng-container>
    <ng-container card-body>
        <ag-grid-row-count [gridOptions]="gridOptions" [gridApi]="gridApi"></ag-grid-row-count>
        <ws-ag-grid-angular [gridOptions]="gridOptions"
                            (gridReady)="onAgGridReady($event)"
                            [pinnedTopRowData]="addedCompanies">
        </ws-ag-grid-angular>
    </ng-container>
</ws-ace-card>
